import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createPurity,
  getAPurity,
  resetState,
  updateAPurity,
} from "../features/purity/puritySlice";
import { getMetal } from "../features/metal/metalSlice";

let schema = yup.object().shape({
  product_purity: yup.string().required("Purity is Required"),
});

const Addpurity = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const getPurityId = location.pathname.split("/")[3];
  const navigate = useNavigate();
    const [selectedMetal, setSelectedMetal] = useState("");
  const newPurity = useSelector((state) => state.purity);
  const metalState = useSelector((state) => state.metal.Metal);
  const {
    isSuccess,
    isError,
    isLoading,
    createdPurity,
    purityName,
    metalName,
    updatedPurity,
  } = newPurity;

  useEffect(() => {
    if (getPurityId !== undefined) {
      dispatch(getAPurity(getPurityId));
    } else {
      dispatch(resetState());
    }
  }, [getPurityId]);

    useEffect(() => {
      dispatch(getMetal());
    }, [dispatch]);

  useEffect(() => {
    if (isSuccess && createdPurity) {
      toast.success("Purity Added Successfully!");
      navigate("/admin/list-purity");
            dispatch(resetState());
    }
    if (isSuccess && updatedPurity) {
      toast.success("Purity Updated Successfully!");
      navigate("/admin/list-purity");
       dispatch(resetState());
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createdPurity, updateAPurity, navigate, dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      product_purity: purityName || "",
      metal_type: metalName || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getPurityId !== undefined) {
        const data = { id: getPurityId, purityData: values };
        dispatch(updateAPurity(data));
      } else {
        dispatch(createPurity(values));
        formik.resetForm();
      }
    },
  });

  const handleMetalChange = (e) => {
    // formik.handleChange(e);
    formik.setFieldValue("metal_type", e.target.value);
    setSelectedMetal(e.target.value);
  };

  return (
    <div>
      <h3 className="mb-4 title">
        {getPurityId !== undefined ? "Edit" : "Add"} Purity
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <div>
            <label className="form-label" htmlFor="product_purity">
              Metal Purity <span className="text-danger">*</span>
            </label>
            <CustomInput
              type="number"
              label="Enter Metal Purity"
              onChng={formik.handleChange("product_purity")}
              onBlr={formik.handleBlur("product_purity")}
              val={formik.values.product_purity}
              id="product_purity"
            />
            <div className="error">
              {formik.touched.product_purity && formik.errors.product_purity}
            </div>
          </div>
          <div>
            <label htmlFor="product_metal" className="sub-title mt-4">
              Product Metal
            </label>
            <select
              name="metal_type"
              onChange={handleMetalChange}
              onBlur={formik.handleBlur("metal_type")}
              value={formik.values.metal_type}
              className="form-control py-1 mb-2 mt-1"
              id=""
            >
              <option value="">Select Metal</option>
              {metalState.map((i, j) => {
                return (
                  <option key={j} value={i._id}>
                    {i.metal_name}
                  </option>
                );
              })}
            </select>
            <div className="error">
              {formik.touched.metal_type && formik.errors.metal_type}
            </div>
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getPurityId !== undefined ? "Edit" : "Add"} Purity
          </button>
        </form>
      </div>
    </div>
  );
};

export default Addpurity;